import React from "react";
import {useTranslation} from "react-i18next";
import {format} from "date-fns";
import "./transactionsDataList.sass";
import {observer} from "mobx-react-lite";
import {useStores} from "../../../stores/useStores";
import NoResultsIcon from "../../atoms/noResultsIcon/noResultsIcon";
import ProcessedBookingItem from "../processedBookingItem/processedBookingItem";

const TransactionsDataList: React.FC = () => {
  const {t} = useTranslation(["translation", "event"]);
  const {
    uiStore: {transactionsUiStore}
  } = useStores();

  const noTransactionsIndication = (
    <div className="no-transactions">
      <NoResultsIcon
        titleText={t("event:labels.transactionsTable.noTransactionsFound", {
          date: format(transactionsUiStore.selectedDate, "MMMM yyyy")
        })}
      />
    </div>
  );

  return (
    <div className="transactions-data-list-accordion accordion">
      {transactionsUiStore.transactions.events.length > 0
        ? transactionsUiStore.transactions.events.map((bookingGroup) => (
            <ProcessedBookingItem
              key={bookingGroup.id}
              bookingGroup={bookingGroup}
            />
          ))
        : noTransactionsIndication}
    </div>
  );
};

export default observer(TransactionsDataList);
